export const adStatus = {
    ACTIVE: 'active',
    BLOCKED: 'blocked',
    DISABLED: 'disabled',
    FEATURED: 'featured',
    LIMITED: 'limited',
    MODERATED: 'moderated',
    MODIFY: 'modify',
    NEW: 'new',
    OUTDATED: 'outdated',
    PENDING: 'pending',
    REJECTED: 'rejected',
    SOLD: 'sold',
    UNCONFIRMED: 'unconfirmed',
    REMOVED_BY_USER: 'removed_by_user',
    REMOVED_BY_ADMIN: 'removed_by_admin',
    REMOVED_BY_MODERATOR: 'removed_by_moderator',
    FEATURED_AUTOBOOST: 'featured_autoboost',
    WAITING_CONFIRMATION: 'WAITING_CONFIRMATION',
    WAITING_CANCELLATION_CONFIRMATION: 'WAITING_CANCELLATION_CONFIRMATION',
    ON_PROGRESS: 'ON_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    WAITING_PAYMENT: 'WAITING_PAYMENT',
    WAITING_CANCELLATION: 'WAITING_CANCELLATION'
};
